import PanelTab from './PanelTab';

export default PanelTab;
